import { createContext as t } from "react";
import { createApplicationMenu as o } from "../../utils/applicationMenu/applicationMenu.js";
const p = t(
  o()
);
export {
  p as ApplicationMenuContext
};
